import { useSyncExternalStore } from "react";

import {
  getActiveExcelBrandTemplateId,
  subscribeExcelBrandTemplate,
} from "../../shared/featureFlags/excelTemplateBrand";
import {
  getExcelBrandDefaults,
  type ExcelBrandDefaults,
} from "../branding/excelBrandDefaults";

export function useExcelActiveBrand(): ExcelBrandDefaults | null {
  const brandId = useSyncExternalStore(
    subscribeExcelBrandTemplate,
    getActiveExcelBrandTemplateId,
    () => "",
  );

  return getExcelBrandDefaults(brandId) ?? null;
}
